<form *ngIf="addPermissionForm" [formGroup]="addPermissionForm" (ngSubmit)="savePermission()" RestrictFocus [style.height.px]="250">
    <div class="ui-grid ui-grid-responsive ui-fluid">

        <div class="ui-grid-row" style="margin-bottom: 10px">
            <div class="ui-grid-col-4"><label>{{ 'permissionForm.operationName' | translate}}</label></div>
            <div class="ui-grid-col-8">
                <!-- <p-dropdown formControlName="operationID" [style]="{'width':'100%'}" (onChange)="selectOperation($event)" [options]="operationsDropwDown"></p-dropdown> -->
                <p-dropdown (onChange)="selectOperation($event)" [options]="operationsDropwDown" [filter]="true" [style]="{'width':'100%'}" formControlName="operationID" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
            </div>
        </div>

        <div class="ui-grid-row" style="margin-bottom: 10px">
            <div class="ui-grid-col-3">
                <p-checkbox formControlName="permGet" [disabled]="!selectedOperation.canCallGET" value="allowsGET" [label]="'permissionForm.allowsGET' | translate" ></p-checkbox>
            </div>
            <div class="ui-grid-col-3">
                <p-checkbox formControlName="permPost" [disabled]="!selectedOperation.canCallPOST" value="allowsPOST" [label]="'permissionForm.allowsPOST' | translate" ></p-checkbox>
            </div>
            <div class="ui-grid-col-3">
                <p-checkbox formControlName="permPut" [disabled]="!selectedOperation.canCallPUT" value="allowsPUT" [label]="'permissionForm.allowsPUT' | translate" ></p-checkbox>
            </div>
            <div class="ui-grid-col-3">
                <p-checkbox formControlName="permDelete" [disabled]="!selectedOperation.canCallDELETE" value="allowsDELETE" [label]="'permissionForm.allowsDELETE' | translate" ></p-checkbox>
            </div>
        </div>

    </div>

    <p-footer>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
            <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" [disabled]="!addPermissionForm.valid || !addPermissionForm.dirty"
                    [label]="labelButton | translate"></button>
        </div>
    </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplicationPermissionsForm.component.html